import React from 'react';
import { connect } from 'react-redux';
import liff from '@line/liff';

import { getTranslation } from '../../translation/translation';
import { callPost } from '../../ajax/server';
import { renderLoadingIcon } from '../../components/loadingIcon/loadingIcon';
import { trackVisit, trackClick } from '../../logger/googleAnalytics';
import ErrorPage from '../errorPage/errorPage';

import './disclaimer.scss';

interface DisclaimerProp {
    textTitle: string;
    textContents: string[];
    textAccept: string;

    textPrivacyTitle: string;
    userId: string;

    lineLiffId: string;

    isInfoOnly: boolean;
}

interface DisclaimerState {
    buttonDisable: boolean;
    isError: boolean;
    isLoading: boolean;
}

class Disclaimer extends React.Component<DisclaimerProp, DisclaimerState> {
    private endContentRef: React.RefObject<HTMLDivElement>;
    private buttonContainerRef: React.RefObject<HTMLDivElement>;

    constructor(props: DisclaimerProp) {
        super(props);

        this.endContentRef = React.createRef();
        this.buttonContainerRef = React.createRef();

        this.state = {
            buttonDisable: true,
            isError: false,
            isLoading: false,
        };
    }

    public componentDidMount() {
        if (this.props.isInfoOnly) {
            trackVisit('disclaimerinfo');
        } else {
            document.addEventListener('scroll', this.handleScroll);
            trackVisit('disclaimer');
        }
    }
      
    public componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = (_: any) => {
        if (this.endContentRef.current !== null &&
            this.buttonContainerRef.current !== null &&
            this.endContentRef.current.getBoundingClientRect().bottom + this.buttonContainerRef.current.getBoundingClientRect().height <= window.innerHeight) {
            this.setState({
                buttonDisable: false
            });
            document.removeEventListener('scroll', this.handleScroll);
        }
    }

    onAcceptClick = () => {
        this.setState({
            isLoading: true,
        });

        // this.props.lineLiffId

        callPost('/easyInvestConnectWebsite/api/disclaimerAgree', { userId: this.props.userId }, this.onAcceptCallback, this.onErrorCallback);
        // call to TVSS here or at disclaimerAgree server side

        trackClick('acceptdisclaimer');

        // CALL TVSS-API with ChannelID(LINE_OA)
    }

    onAcceptCallback = (response: any) => {
        try {
            const res = JSON.parse(response);

            if (res.code === 'SUCCESS') {
                liff.closeWindow();
            } else {
                this.setState({
                    isError: true,
                });
            }
        } catch {
            this.setState({
                isError: true,
            });
        }
    }

    onErrorCallback = () => {
        this.setState({
            isError: true,
        });
    }

    onCloseClick = () => {
        liff.closeWindow();
    }

    onErrorButtonClick = () => {
        this.setState({
            buttonDisable: true,
            isError: false,
            isLoading: false,
        });

        document.addEventListener('scroll', this.handleScroll);
    }

    private renderButton(): JSX.Element {
        if (this.props.isInfoOnly) {
            return <button className='disclaimer-button accept-button' onClick={this.onCloseClick}>{this.props.textAccept}</button>;
        }

        return this.state.isLoading ?
            <button className='disclaimer-button loading-button' disabled={true}>{renderLoadingIcon('loading-symbol')}</button> :
            <button className='disclaimer-button accept-button' disabled={this.state.buttonDisable} onClick={this.onAcceptClick}>{this.props.textAccept}</button>;
    }

    private renderDisclaimer(): JSX.Element {
        return (
            <React.Fragment>
                <h2 className='disclaimer-title'>{this.props.textTitle}</h2>
                <div className='disclaimer-content'>
                    {this.props.textContents.map((x, index) => {
                        let classname: string = 'content-tab';

                        if (index === 0) {
                            classname = 'content-underline';
                        } else if  (index === this.props.textContents.length - 1) {
                            return null;
                        }

                        return <div key={`content_${index}`} className={classname}>{x}</div>;
                    })}
                </div>
                <h2 className='disclaimer-title'>{this.props.textPrivacyTitle}</h2>
                <div className='disclaimer-content' ref={this.endContentRef}>
                    {this.props.textContents[this.props.textContents.length - 1]}
                    <div>
                        (<a
                            href="https://www.innovestx.co.th"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.innovestx.co.th
                        </a>)
                    </div>
                </div>
                <div className='button-container' ref={this.buttonContainerRef}>
                    {this.renderButton()}
                </div>
            </React.Fragment>
        );
    }

    public render() {
        if (this.state.isError) {
            return <ErrorPage onErrorButtonClick={this.onErrorButtonClick} />;
        }

        return this.renderDisclaimer();
    }
}

const mapStateToProps = (state: any) => {
    // TODO: Complete this DB content
    const textContents = [
        // 'HELLO!!!',
        // 'L: ' + state.initReducer.lineLiffId,
        // 'U: ' + state.initReducer.userId,
        getTranslation(state, 1001),
        getTranslation(state, 1002),
        getTranslation(state, 1003),
        getTranslation(state, 1004),
        getTranslation(state, 1005),
        getTranslation(state, 1006),
        getTranslation(state, 2001),
    ];


    return {
        textContents,
        textTitle: getTranslation(state, 1000),
        textAccept: getTranslation(state, 9),
        textPrivacyTitle: getTranslation(state, 2000),      
        userId: state.initReducer.userId,
        lineLiffId: state.initReducer.lineLiffId
    };
}

export default connect(mapStateToProps)(Disclaimer);
export const DisclaimerComponent = Disclaimer;
